module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/DownloadedFile-dd20d3cf598a95f720b520787f62620a.svg";